<template>
  <div
    class="w-full bg-white pl-4 py-4 font-medium shadow-sm select-none flex justify-between px-4"
  >
    <div>
      <router-link to="/">
        <font-awesome-icon icon="crow" class="text-xl font-medium text-pastel-green-600"/>
        <h1 class="ml-2 tracking-widest">Raven</h1>
      </router-link>
    </div>
    <div class="text-xs self-center">
      <div
        class="font-medium text-gray-600 flex hover:cursor-pointer hover:text-gray-700 text-center"
        @click="handleSubmit"
      >
        <div v-if="me" class="self-center mr-2">
          <font-awesome-icon
            v-if="me.role == 'Administrator'"
            icon="shield-alt"
            class="text-lg text-pastel-red self-center pt-1"
          />

          {{ me.name }}
        </div>
        <font-awesome-icon icon="sign-out-alt" class="text-lg self-center"/>
      </div>
    </div>
  </div>
</template>

<script>
import UsersService from "@/helpers/services/users.service";

export default {
  name: "LHeader",
  data() {
    return {
      me: undefined
    };
  },
  methods: {
    async handleSubmit() {
      await UsersService.signOut();
      window.location.href = "/login";
    }
  },
  async created() {
    try {
      this.me = await UsersService.me();
    } catch (e) {}
  }
};
</script>


<style lang="postcss" scoped>
h1 {
  @apply text-lg font-bold inline-block;
}

a {
  text-decoration: none;
  @apply text-pastel-black;
}
</style>
